import React from "react";
import { WARRANTY_STEP } from "../../common/constant";
import InformationCustomer from "./infoCustomer";
import InformationProduct from "./infoProduct";
import "./resultRegisterStyle.scss";

const ResultRegisterWarranty = (props: any) => {
  return (
    <>
      {/* <div className="result-register-warranty"> */}
      <p className="result-register-warranty__title main-title">
        Ghi nhận thành công!
      </p>

      <p className="result-register-warranty__guide main-content">
        Thông tin bảo hành của Quý khách đã được ghi nhận thành công, được lưu
        trữ online và có giá trị tương đương phiếu bảo hành giấy.
        <br />
        Để xem lại thông tin bảo hành đã đăng ký, Quý khách có thể Scan lại mã
        QR bảo hành trên sản phẩm.
      </p>
      <p className="result-register-warranty__guide main-content">
        Tham khảo thêm chi tiết chế độ bảo hành{" "}
        <a
          href="https://www.kymdan.com/bai-viet/thong-tin-bao-hanh"
          target="blank"
          className="result-register-warranty--link">
          tại đây
        </a>
      </p>
      <p className="result-register-warranty__guide main-content">
        Cảm ơn Quý khách!
      </p>
      <>
        <InformationProduct />

        <InformationCustomer step={WARRANTY_STEP.RESULT} />
      </>

      <div className="result-register-warranty__home main-content">
        <a onClick={() => props.history.push("/")}>Quay lại trang chủ</a>
      </div>

      {/* </div> */}
    </>
  );
};

export default ResultRegisterWarranty;
